import { INITIALIZE, SEND_DIAGNOSTICS, SEND_FINISHED } from './constants';

export function sendFinished() {
  return {
    type: SEND_FINISHED,
  };
}

export function sendDiagnostics() {
  return {
    type: SEND_DIAGNOSTICS,
  };
}

export function initialize() {
  return {
    type: INITIALIZE,
  };
}
